/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Trust_NobyokInputs */

const en_landing_trust_nobyok = /** @type {(inputs: Landing_Trust_NobyokInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No API keys needed`)
};

const de_landing_trust_nobyok = /** @type {(inputs: Landing_Trust_NobyokInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine API-Keys noetig`)
};

const fr_landing_trust_nobyok = /** @type {(inputs: Landing_Trust_NobyokInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune clé API requise`)
};

const es_landing_trust_nobyok = /** @type {(inputs: Landing_Trust_NobyokInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin claves API necesarias`)
};

const it_landing_trust_nobyok = /** @type {(inputs: Landing_Trust_NobyokInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna chiave API necessaria`)
};

const nl_landing_trust_nobyok = /** @type {(inputs: Landing_Trust_NobyokInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen API-sleutels nodig`)
};

const pl_landing_trust_nobyok = /** @type {(inputs: Landing_Trust_NobyokInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bez klucza API`)
};

const fi_landing_trust_nobyok = /** @type {(inputs: Landing_Trust_NobyokInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei API-avaimia tarvita`)
};

const da_landing_trust_nobyok = /** @type {(inputs: Landing_Trust_NobyokInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen API-nøgler nødvendige`)
};

const sv_landing_trust_nobyok = /** @type {(inputs: Landing_Trust_NobyokInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga API-nycklar behövs`)
};

/**
* | output |
* | --- |
* | "No API keys needed" |
*
* @param {Landing_Trust_NobyokInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_trust_nobyok = /** @type {((inputs?: Landing_Trust_NobyokInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Trust_NobyokInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_trust_nobyok(inputs)
	if (locale === "fr") return fr_landing_trust_nobyok(inputs)
	if (locale === "es") return es_landing_trust_nobyok(inputs)
	if (locale === "it") return it_landing_trust_nobyok(inputs)
	if (locale === "nl") return nl_landing_trust_nobyok(inputs)
	if (locale === "pl") return pl_landing_trust_nobyok(inputs)
	if (locale === "fi") return fi_landing_trust_nobyok(inputs)
	if (locale === "da") return da_landing_trust_nobyok(inputs)
	if (locale === "sv") return sv_landing_trust_nobyok(inputs)
	return en_landing_trust_nobyok(inputs)
});